const saasOnShopPrefix = 'SaasOnShop';
const SAAS_ON_SHOP = {
  MODIFY_SOFTWARE: `${saasOnShopPrefix}:ModifySoftware`,
  VIEW_CART: `${saasOnShopPrefix}:ViewCart`,
  CONTINUE_TO_CART: `${saasOnShopPrefix}:ContinueToCart`,
  REDIRECT_TO_CART: `${saasOnShopPrefix}:RedirectToCart`,
};

const CHECKOUT = Object.freeze({
  REVIEW: {
    REACH_PAYMENT_ISSUER_INSTALLMENTS_ERROR:
      'Reach Payment Issuer Installments Error',
    COMPLETING_ORDER_ERROR_PAYMENT: 'Completing Order Error Payment',
    COMPLETING_ORDER_ERROR_GENERAL: 'Completing Order Error General',
  },
  PAYMENT: {
    VIEW_ISSUER_INSTALLMENT_OPTIONS: 'View Issuer Installment Options',
  },
});

export const SHIPPING_INFORMATION_VALIDATION = {
  REQUEST_SUCCESS: 'Address Validation:API Request Success',
  REQUEST_ERROR: 'Address Validation:API Request Error',
  VERIFIED: 'Address Validation:Verified',
  PARTIALLY_VERIFIED: 'Address Validation:Partially Verified',
  FAILED_VERIFICATION: 'Address Validation:Verification Failed',
  CTA: {
    USE_ORIGINAL: 'Address Validation:Use Original Click',
    USE_SUGGESTED: 'Address Validation:Use Suggested Click',
    ENTER_NEW: 'Address Validation:Enter New Click',
    CLOSE_MODAL: 'Address Validation:Close Modal Click',
  },
};

// Add your event name map here
const CDP_EVENT_NAMES = {
  CHECKOUT,
  SAAS_ON_SHOP,
};

export default CDP_EVENT_NAMES;
